import m from "../../../../geodata/es2015/region/world/latinAmericaHigh";
window.am4geodata_region_world_latinAmericaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/latinAmericaHigh.js
// module id = null
// module chunks = 